export default {
  INSERT_NEW_RESERVATION_TIMING_LOADING: 'INSERT_NEW_RESERVATION_TIMING_LOADING',
  INSERT_NEW_RESERVATION_TIMING_REJECT: 'INSERT_NEW_RESERVATION_TIMING_REJECT',
  INSERT_NEW_RESERVATION_TIMING_FAILED: 'INSERT_NEW_RESERVATION_TIMING_FAILED',
  INSERT_NEW_RESERVATION_TIMING_SUCCESS: 'INSERT_NEW_RESERVATION_TIMING_SUCCESS',

  UPDATE_RESERVATION_TIMING_LOADING: 'UPDATE_RESERVATION_TIMING_LOADING',
  UPDATE_RESERVATION_TIMING_REJECT: 'UPDATE_RESERVATION_TIMING_REJECT',
  UPDATE_RESERVATION_TIMING_FAILED: 'UPDATE_RESERVATION_TIMING_FAILED',
  UPDATE_RESERVATION_TIMING_SUCCESS: 'UPDATE_RESERVATION_TIMING_SUCCESS',

  GET_ALL_RESERVATION_TIMING_LIST_LOADING: 'GET_ALL_RESERVATION_TIMING_LIST_LOADING',
  GET_ALL_RESERVATION_TIMING_LIST_REJECT: 'GET_ALL_RESERVATION_TIMING_LIST_REJECT',
  GET_ALL_RESERVATION_TIMING_LIST_FAILED: 'GET_ALL_RESERVATION_TIMING_LIST_FAILED',
  GET_ALL_RESERVATION_TIMING_LIST_SUCCESS: 'GET_ALL_RESERVATION_TIMING_LIST_SUCCESS',

  GET_RESERVATION_TIMING_DETAILS_LOADING: 'GET_RESERVATION_TIMING_DETAILS_LOADING',
  GET_RESERVATION_TIMING_DETAILS_REJECT: 'GET_RESERVATION_TIMING_DETAILS_REJECT',
  GET_RESERVATION_TIMING_DETAILS_FAILED: 'GET_RESERVATION_TIMING_DETAILS_FAILED',
  GET_RESERVATION_TIMING_DETAILS_SUCCESS: 'GET_RESERVATION_TIMING_DETAILS_SUCCESS',

  DELETE_RESERVATION_TIMING_LOADING: 'DELETE_RESERVATION_TIMING_LOADING',
  DELETE_RESERVATION_TIMING_REJECT: 'DELETE_RESERVATION_TIMING_REJECT',
  DELETE_RESERVATION_TIMING_FAILED: 'DELETE_RESERVATION_TIMING_FAILED',
  DELETE_RESERVATION_TIMING_SUCCESS: 'DELETE_RESERVATION_TIMING_SUCCESS',
};